import { takeEvery, put } from 'redux-saga/effects'
import { ADD_XMC, ADD_XMC_SUCCESS_NOTIFY, getTruckModules } from 'actions/truck'

export default function* watchAddXmcSuccess() {
  yield takeEvery(ADD_XMC, addXmcSideEffects)
}

function* addXmcSideEffects({ serialNumber, modulesWithNames = [] }) {
  yield put(getTruckModules({ serialNumber }))

  if (modulesWithNames.length) {
    yield put({
      type: ADD_XMC_SUCCESS_NOTIFY,
      modules: modulesWithNames,
    })
  }
}
